<template>
  <v-container fluid>
    <v-card tile class="mt-2">
      <a-table size="small" bordered :columns="headers" :data-source="list" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" row-key="_id">
        <template slot="title">
          <v-row>
            <v-col cols="8">
              <v-autocomplete v-model="queryForm.postoffices" :items="postoffices" label="派押局"
                :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" multiple clearable outlined dense
                hide-details>
              </v-autocomplete>
            </v-col>
            <v-col cols="2">
              <v-autocomplete v-model="queryForm.show_all" :items="[
                { value: -1, text: '全部' },
                { value: 1, text: '在线' },
                { value: 0, text: '离线' },
              ]" label="账号状态" :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense
                hide-details>
              </v-autocomplete>
            </v-col>
            <v-col cols="2">
              <a-space>
                <v-btn tile class="primary white--text" @click="getdata()">
                  <v-icon>mdi-magnify</v-icon>查询
                </v-btn>
                <v-btn tile class="success white--text" @click="showadd()">
                  <v-icon>mdi-plus</v-icon>添加
                </v-btn>
              </a-space>
            </v-col>
          </v-row>
        </template>
        <template slot="index" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <template slot="state" slot-scope="text, record">
          <a-space>
            <a-tag :color="record.state === 1 ? 'green' : 'red'">{{ record.state === 1 ? '在线' : '离线' }}</a-tag>
            <span>{{ record.utime }}</span>
          </a-space>
        </template>
        <template slot="notify" slot-scope="text, record">
          <a-space>
            <a-switch v-model="record.notify" @change="update(record._id, 'notify', record.notify)"></a-switch>
            <a-tag :color="record.notify === true ? 'green' : 'red'">{{ record.notify === true ? '开启' : '关闭' }}</a-tag>
          </a-space>
        </template>
        <template slot="remark" slot-scope="text, record">
          <a-input v-model="record.remark" @blur="() => update(record._id, 'remark', record.remark)"></a-input>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <v-btn text tile color="success" @click="showedit(record)"> 编辑 </v-btn>
            <a-popconfirm title="删除抓取账号" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)">
              <v-btn text tile color="error"> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </v-card>
    <v-dialog v-model="model" width="400">
      <a-card title="车管平台账号">
        <a-space slot="extra">
          <a-checkbox v-model="continue_add">连续添加</a-checkbox>
          <a-button type="danger" :loading="saving" :disabled="saving" @click="save"> 提交保存
          </a-button>
          <a-button @click="model = false"> 取消
          </a-button>
        </a-space>
        <a-form-model ref="formRef" :model="form" layout="vertical">
          <a-row :gutter="16">
            <a-col :span="24">
              <a-form-model-item label="邮局" prop="postoffice">
                <a-input v-model="form.postoffice" placeholder="邮局" :disabled="saving" allow-clear>
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="账号" prop="login_id">
                <a-input v-model="form.login_id" placeholder="账号" :disabled="saving" allow-clear>
                </a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "CptmcpAccount",
  data() {
    return {
      queryForm: {
        show_all: 1,
        postoffices: [],
      },
      form: {},
      saving: false,
      list: [],
      postoffices: [],
      headers: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "邮局", dataIndex: "postoffice", scopedSlots: { customRender: "postoffice" }, width: 150, align: "center" },
        { title: "账号", dataIndex: "login_id", scopedSlots: { customRender: "login_id" }, width: 150, align: "center" },
        { title: "状态", dataIndex: "state", scopedSlots: { customRender: "state" }, width: 120, align: "center" },
        { title: "通知", dataIndex: "notify", scopedSlots: { customRender: "notify" }, width: 120, align: "center" },
        { title: "备注", dataIndex: "remark", scopedSlots: { customRender: "remark" }, width: 120, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 200, align: "center" },
      ],
      height: 600,
      model: false,
      continue_add: false,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
  },
  components: {},
  watch: {
  },
  mounted() {
  },
  activated() {
    this.list = [];
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/cptmcp/accounts", this.queryForm).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.postoffices = res.data.postoffices;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.form = {
        _id: "",
        postoffice: "",
        login_id: "",
      };
      this.model = true;
    },
    showedit(item) {
      this.form = {
        _id: item._id,
        postoffice: item.postoffice,
        login_id: item.login_id,
      };
      this.model = true;
    },
    save() {
      this.$toast.loading({ message: "" });
      this.saving = true;
      this.$api.doAPI("/cptmcp/saveaccount", { form: this.form }).then((res) => {
        this.$toast.clear();
        // console.log(res);
        this.saving = false;
        if (res.code === 0) {
          this.model = this.continue_add;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.saving = false;
        this.$toast.clear();
        console.error(err);
      });
    },
    update(_id, key, value) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/cptmcp/updateaccount", { _id, key, value }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/cptmcp/removeaccount", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: unset;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-body>table>.ant-table-thead>tr>th {
  padding: 0;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-body>table>.ant-table-tbody>tr>td {
  padding: 0;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
